import type {
  AccessibilityWizardPanelState,
  InitialData,
} from '@wix/a11y-wizard';

export const SET_INITIAL_DATA = 'a11yWizardPanelState/initialData';

export const SET_PANEL_STATE = 'a11yWizardPanelState/panelState';

export const a11yWizardActions = {
  setInitialData: (value: InitialData | undefined) => ({
    type: SET_INITIAL_DATA,
    value,
  }),
  setPanelState: (value: AccessibilityWizardPanelState | undefined) => ({
    type: SET_PANEL_STATE,
    value,
  }),
} as const;
